module.exports = __webpack_public_path__ + "img/deadgods.6ff07093.png";